import { Col, Row, Typography } from 'antd';
import { DocumentCard } from 'features/Dashboard/ui/DocumentCard';
import { FolderCard } from 'features/Dashboard/ui/folder-card';
import { Fragment, useState } from 'react';

import { SecondSubCategoryDocumentView } from './second-sub-category';
const { Title } = Typography;

export const SubCategoryDocumentView = ({
  subCategoryDocument,
  setCategoryList,
  setShowSubCategory,
  setCommentsInfo,
  setAddCommentsModal,
}: any) => {
  const [showSubSecondCategory, setShowSubSecondCategory] = useState(true);
  const [showSecondCategory, setShowSecondCategory] = useState(false);
  const [secondCategoryData, setSecondCategoryData] = useState({});
  const showCategory = () => {
    setCategoryList(true);
    setShowSubCategory(false);
  };

  const showSecondCategoryData = (data: any) => {
    setShowSubSecondCategory(false);
    setShowSecondCategory(true);
    setSecondCategoryData(data);
  };
  const handleAddComment = (document: any) => {
    setAddCommentsModal(true);
    setCommentsInfo(document);
  };

  return (
    <Fragment>
      <Typography className='ctgrybx'>
        {showSubSecondCategory && (
          <ul>
            <li>
              <a href='javascript:void();' onClick={() => showCategory()}>
                Categories
              </a>
            </li>

            <li>{subCategoryDocument.categoryName}</li>
          </ul>
        )}
      </Typography>

      {showSubSecondCategory && (
        <Row gutter={[16, 16]} justify='start' align='top' className='mb-4'>
          {Array.isArray(subCategoryDocument.subCategoryList) &&
          subCategoryDocument.subCategoryList.length
            ? subCategoryDocument.subCategoryList?.map(
                (item: any, index: number) => {
                  return (
                    <Col
                      key={index}
                      xxl={6}
                      xl={8}
                      lg={8}
                      md={12}
                      sm={24}
                      role='button'
                      className='self-stretch'
                    >
                      {' '}
                      <FolderCard
                        name={item.subCategory}
                        noOfDocuments={item.noOfDocuments}
                        lastUpdatedDate={item.lastUpdatedDate}
                        onClick={() => showSecondCategoryData(item)}
                        isEmpty={item.noOfDocuments === 0}
                      />
                    </Col>
                  );
                },
              )
            : ''}
        </Row>
      )}
      {showSubSecondCategory && (
        <Col span={24}>
          <Title level={4} className='antialiased'>
            Document
          </Title>
          <Fragment>
            <Row gutter={[16, 16]} justify='start' align='top' className='mb-4'>
              {Array.isArray(subCategoryDocument.documentList) &&
              subCategoryDocument.documentList.length
                ? subCategoryDocument.documentList?.map(
                    (item: any, index: number) => (
                      <Col
                        key={index}
                        xxl={6}
                        xl={8}
                        lg={8}
                        md={12}
                        sm={24}
                        role='button'
                        className='self-stretch'
                      >
                        {' '}
                        <DocumentCard
                          document={item}
                          onAddComment={handleAddComment}
                        />
                      </Col>
                    ),
                  )
                : ''}
            </Row>
          </Fragment>
        </Col>
      )}
      {showSecondCategory && (
        <SecondSubCategoryDocumentView
          secondCategoryDocument={secondCategoryData}
          setCategoryList={setCategoryList}
          setShowSubCategory={setShowSubCategory}
          subCategoryName={subCategoryDocument.categoryName}
          setShowSecondCategory={setShowSecondCategory}
          setShowSubSecondCategory={setShowSubSecondCategory}
          setCommentsInfo={setCommentsInfo}
          setAddCommentsModal={setAddCommentsModal}
          subCategoryDocument={subCategoryDocument}
        />
      )}
    </Fragment>
  );
};
